import React from 'react';
import { LTText, LTBox } from '@lambdatestincprivate/lt-components';
import NoAccessibilityIssuesIllustration from '../../assets/accessibility/NoAccessibilityIssuesIllustration';

const ZeroAccessibilityIssues = () => {
  return (
    <LTBox
      display="flex"
      justifyContent="center"
      flexDirection="column"
      alignItems="center"
      padding={'64px'}
    >
      <NoAccessibilityIssuesIllustration />
      <LTText
        as="span"
        fontSize={LTText.FontSize.FONT_16}
        fontWeight={600}
        marginTop="24px"
      >
        No accessibility issues found!
      </LTText>
      <LTText
        as="span"
        fontSize={LTText.FontSize.FONT_14}
        fontWeight="400"
        marginTop="4px"
        color="fg.muted"
        textAlign="center"
        style={{ maxWidth: '480px' }}
      >
        Seamless accessibility achieved! Your platform is user-friendly
        experience, with no accessibility issues.
      </LTText>
    </LTBox>
  );
};

export default ZeroAccessibilityIssues;
